import PropTypes from 'prop-types';
import React from 'react';

import { ArrowLink, PrimaryLink } from '../Common/Links';
import BlindFormCta from '../Common/MarketoForm/BlindFormCta';
import { smoothScrollToOffset } from '../Common/ScrollTo';
import * as styles from './HeadingCtas.module.scss';

const HeadingCtas = ({ ctas = [], inheritColor, className, bkColor }) => {
  if (!ctas || ctas.length === 0) return null;
  if (ctas.length === 1 && ctas[0].linkStyle === 'Arrow Link') {
    return (
      <HeadingCta primaryClick={ctas[0].onPrimaryClick} cta={ctas[0]} bkColor={bkColor} inheritColor={inheritColor} />
    );
  }
  return (
    <div className={[styles.ctas, className].join(' ')}>
      {ctas.map((cta, i) => {
        return (
          <HeadingCta
            primaryClick={ctas[0].onPrimaryClick}
            key={i}
            cta={cta}
            bkColor={bkColor}
            inheritColor={inheritColor}
          />
        );
      })}
    </div>
  );
};

export const HeadingCta = ({ cta, bkColor, inheritColor, primaryClick, isBlindClick = false }) => {
  //const [open, setOpen] = useState(false);

  if (!cta) {
    return null;
  }

  /*
  Note: MOPs wants the query string - specifically the utms - to be retained
  between pages.  Since these links rely on programmatic behavior, we have to
  apply the query string to the url provided by contentful
   */

  let url = cta.url;
  let hash = '';
  const opensModal = cta.openContentInModal && cta.modalContent;

  if (url?.includes('#')) {
    [url, hash] = url.split('#');
  }

  if (url && typeof window !== 'undefined') {
    const querystring = window.location.search;
    if (querystring) {
      if (url.includes('?')) {
        url += '&' + querystring.substring(1);
      } else {
        url += querystring;
      }
    }
  }

  const scroll = () => {
    if (typeof window !== 'undefined' && hash) {
      let el = document.getElementById(hash);
      if (el) {
        smoothScrollToOffset(el, 84);
      }
    }
  };

  const onPrimaryClick = (e) => {
    e.preventDefault();
    if (primaryClick) {
      return primaryClick();
    }

    if (hash) {
      scroll();
    } else {
      if (cta.opensNewPage) window.open(url, '_blank');
      else window.location.href = url;
    }
  };

  let primary = !cta.linkStyle || cta.linkStyle === 'Primary Button';
  if (!isBlindClick && opensModal && cta.modalContent?.marketoFormId) {
    return <BlindFormCta cta={cta} inheritColor={inheritColor} bkColor={bkColor} />;
  }
  return (
    <>
      {cta.linkStyle === 'Start now arrow' && (
        <>
          <div className={styles.breaker}></div>
          <div className={styles.startNowWrap}>
            <span className={styles.startNowText}>{cta.linkText}</span>
            <ArrowLink
              label={'Start now'}
              isArrowDown={false}
              onClick={onPrimaryClick}
              url={url}
              inheritColor={inheritColor}
              className={styles.startNow}
              data-analytics-component={'arrow-link'}
              data-analytics-id={url}
            />
          </div>
        </>
      )}
      {cta.linkStyle === 'Arrow Link' && (
        <ArrowLink
          label={cta.linkText}
          isArrowDown={cta.isJumpLink}
          onClick={onPrimaryClick}
          url={cta.isJumpLink ? '' : url}
          inheritColor={inheritColor}
          data-analytics-component={'arrow-link'}
          data-analytics-id={url}
        />
      )}
      {primary && (
        <PrimaryLink
          label={cta.linkText}
          onClick={onPrimaryClick}
          backgroundColor={bkColor}
          isButton={true}
          url={url}
          data-analytics-component={'primary-link'}
          data-analytics-id={url}
        />
      )}
      {cta.linkStyle === 'Secondary Button' && (
        <PrimaryLink
          label={cta.linkText}
          onClick={onPrimaryClick}
          isButton={true}
          url={url}
          backgroundColor={'white'}
          data-analytics-component={'secondary-button'}
          data-analytics-id={url}
        />
      )}
      {cta.linkStyle === 'Outlined Button' && (
        <PrimaryLink
          label={cta.linkText}
          onClick={onPrimaryClick}
          isButton={true}
          url={url}
          outlined={true}
          data-analytics-id={url}
          data-analytics-component={'outlined-primary-button'}
        />
      )}
    </>
  );
};

HeadingCtas.propTypes = {
  ctas: PropTypes.arrayOf(
    PropTypes.shape({
      linkText: PropTypes.string,
      linkStyle: PropTypes.string,
      url: PropTypes.string,
      opensNewPage: PropTypes.bool,
      opensVideoModal: PropTypes.bool,
      isJumpLink: PropTypes.bool,
    })
  ).isRequired,
  bkColor: PropTypes.string,
};

export default HeadingCtas;
